import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-fedex',
  templateUrl: './admin-manage-fedex.component.html',
  styleUrls: ['./admin-manage-fedex.component.scss'],
})
export class AdminManageFedexComponent implements OnInit {

  carrierNameError: string;
  clientIdError: string;
  clientSecretError: string;
  carrierId: any;
  fedexList: any = {};

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.fedexList = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.fedexList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  clientIdBlur() {
    this.clientIdError = "";
    if (!this.fedexList.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
  }

  clientSecretBlur() {
    this.clientSecretError = "";
    if (!this.fedexList.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.clientIdError = "";
    this.clientSecretError = "";

    if (!this.fedexList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.fedexList.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (!this.fedexList.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }

    if (this.carrierNameError != "" || this.clientSecretError != "" || this.clientIdError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "clientId": this.fedexList.clientId,
      "carrierCode": this.fedexList.carrierCode,
      "connectionName": this.fedexList.connectionName,
      "organizationId": this.fedexList.organizationId,
      "carrierId": this.fedexList.carrierId,
      "clientSecret": this.fedexList.clientSecret
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Fed Ex', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
